import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage  } from 'react-localize-redux';
import FileFileDownload from 'material-ui/svg-icons/file/file-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import globalStyles from 'layouts/material-admin/globalStyles';
import styles from './styles/searchPageStyles';
import DownloadModal from 'containers/downloadButtons/DownloadModal';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import NoResultsBox from 'components/noResults/NoResultsBox';
import AgGridTableCtrl from 'components/table/AgGridTableCtrl';
import * as cookieServices from 'services/cookies/cookieServices';
import * as icnActions from 'actions/icnActions';
import SearchButton from 'containers/search/SearchButton';

import {searchICNList, cancelSearchICNListRequest} from 'actions/icnActions';
import {SaveRowIndex, ClearRowIndex} from 'actions/gridActions';

class SearchPage extends Component {

    constructor(props) {
        super(props);

        this.getInitiaSearchDataValues = this.getInitiaSearchDataValues.bind(this);
        this.getInitialPaginationValues = this.getInitialPaginationValues.bind(this);

        this.handlePagination = this.handlePagination.bind(this);
        this.handlePageSizeChanged = this.handlePageSizeChanged.bind(this);
        this.handleSelectedRows = this.handleSelectedRows.bind(this);

        /*
            per la gestione call bak function del searchbutton
        */
        this.handleSearchCallback = this.handleSearchCallback.bind(this);
        this.handleClearSearchCallBack = this.handleClearSearchCallBack.bind(this);

        /*
            eventi della griglia: sort, row click
        */
        this.handleSortChanged = this.handleSortChanged.bind(this);
        this.handleRowClicked = this.handleRowClicked.bind(this);

        /*
            per gestire la cancellazione di una ricerca se preme "cancel" durante una ricerca
        */
        this.handleCancelSearch = this.handleCancelSearch.bind(this);

        /*
            per gestire il bottone di download
        */
        this.toggleDownloadExpand = this.toggleDownloadExpand.bind(this);

        var source = icnActions.getSearchICNListCancelSource();

        this.state = {
            searchData: this.getInitiaSearchDataValues(props),
            pagination: this.getInitialPaginationValues(),
            isSelectedAll: false,
            modalOpen: false,
            isSearching: props.isSearching,
            // per la gestione dei selected rows
            selectedDataList: [],
            isDownloadExpanded: false,
            cancelSource: source
        };

        this.props.searchICNList(this.state.searchData, this.state.pagination, source.token);

    }

    /**
     * toggle per il popup modal di download
     */
    toggleDownloadExpand(){
        this.setState({isDownloadExpanded: !this.state.isDownloadExpanded});
    }

    /**
     * modal popup - search form
     */
    handleRowClicked = (event) => {
        this.props.SaveRowIndex(event.rowIndex);
    };

    /**
     * valori di default per searchData
     * @param {props dove sono state salvate le liste di severityCodeList e eventClassificationList dalla mappatura state-component} props
     */
    getInitiaSearchDataValues(props, isClear){
        var dateFrom = new Date();
        dateFrom = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate(), 0, 0, 0)
        dateFrom.setMonth(dateFrom.getMonth() - 6);
        var savedFilters = cookieServices.getSeachFilters();
        var dateTo = new Date();
        dateTo = new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate(), 23, 59, 59)

        if(!isClear && savedFilters)
        {
            return {
                icnId: savedFilters.icnId,
                vin: savedFilters.vin,
                deviceFilterValue: savedFilters.deviceFilterValue,
                dateFrom: new Date(savedFilters.dateFrom),
                dateTo: new Date(savedFilters.dateTo),
                severityCodeList: props.severityCodeList,
                selectedSeverityValues: savedFilters.selectedSeverityValues,
                eventClassificationList: props.eventClassificationList,
                selectedClassificationValue: savedFilters.selectedClassificationValue,
                selectedDeviceIdType: savedFilters.selectedDeviceIdType,
                includeSubAccount: savedFilters.includeSubAccount,
                selectedAccount: savedFilters.selectedAccount
            }
        }
        return {
            icnId: '',
            vin: '',
            deviceFilterValue: '',
            dateFrom: dateFrom,
            dateTo: dateTo,
            severityCodeList: props.severityCodeList,
            selectedSeverityValues: ['AllCrashesButNonNonCrash'],
            eventClassificationList: props.eventClassificationList,
            selectedClassificationValue: null,
            selectedDeviceIdType: "ESN",
            includeSubAccount: true,
            selectedAccount: null
        }
    }

    /**
     * valori di default per l'impaginazione
     * @param {props dove sono state salvate le severityCodeList  e eventClassificationList dalla mappatura state-component} props
     */
    getInitialPaginationValues(isClear){

        var saved = cookieServices.getPagination();

        if(!isClear && saved)
        {
            return {
                // pagina corrente
                currentPage: saved.currentPage,
                // impaginazioni disponibili
                pageSizeList: saved.pageSizeList,
                // impaginazione scelta
                selectedPageSize: saved.selectedPageSize,
                sortName: saved.sortName,
                isDescending: saved.isDescending
            }
        }
        return {
            // pagina corrente
            currentPage: 1,
            // impaginazioni disponibili
            pageSizeList: [10, 20, 50, 100, 200],
            // impaginazione scelta
            selectedPageSize: 20,
            sortName: 'crashDate',
            isDescending: true
        }
    }

    /*
        gestione selezione dei record dalla griglia - checkbox
    */
    handleSelectedRows(data){
        /*
            cerco l'elemento per id:
                -   se lo trovo allora devo eliminarlo
                -   se non lo trovo allora lo aggiungo
        */
        var { selectedDataList } = this.state;

        var filter = selectedDataList.filter(x => x === data);
        if(!filter || filter.length <= 0)
        {
            selectedDataList.push(data);
        }
        else{
            selectedDataList = selectedDataList.filter(x => x !== data);
        }

        this.setState({ selectedDataList });
    }

    /**
     *
     * @param {nome colonna} dataName
     * @param {true se DESC} isDescending
     */
    handleSortChanged(dataName, isDescending){
        var sortName = dataName.replace("icn.", "");

        var { pagination } = this.state;
        pagination.isDescending = isDescending;
        pagination.sortName = sortName;
        this.setState({ pagination });

        cookieServices.savePagination(this.state.pagination);
        this.props.ClearRowIndex();
        this.props.searchICNList(this.state.searchData, this.state.pagination);
    }

    /**
     * gestione cambio pagina
     * @param {*} state
     */
    handlePagination(newCurrentPage){
        var { pagination } = this.state;
        pagination.currentPage = newCurrentPage;
        this.setState({ pagination });

        cookieServices.savePagination(this.state.pagination);
        this.props.ClearRowIndex();
        this.props.searchICNList(this.state.searchData, this.state.pagination);
    }

    /**
     * gestione cambio pagesize
     * @param {*} state
     */
    handlePageSizeChanged(newSelectedPageSize){
        var { pagination } = this.state;

        // impaginazione scelta - se è cambiata si parte sempre dalla prima pagina
        if(pagination.selectedPageSize !== newSelectedPageSize)
        {
            pagination.currentPage = 1;
        }
        pagination.selectedPageSize = newSelectedPageSize;
        this.setState({ pagination });

        this.props.ClearRowIndex();
        this.props.searchICNList(this.state.searchData, this.state.pagination);
    }

    /**
     * annulla ricerca su ICN
     */
    handleCancelSearch(){
        var { cancelSource } = this.state;
        if(!cancelSource) return;

        this.props.cancelSearchICNListRequest(cancelSource);
    }

    /**
     *
     * @param {filtri selezionati dal SearchButton} data
     */
    handleSearchCallback(data){
        /*
            scateno dispatch per la ricerca icn list.
            ogni volta che si clicca su Search si parte sempre dalla prima pagina
        */
        console.info("handleSearchCallback")
        console.info(data);
        var { pagination } = this.state;
        pagination.currentPage = 1;

        /*
            recupero token per annullare la ricerca
            la ricerca si annulla tramite handleCancelSearch invocato dal SearchButton
        */
        var source = icnActions.getSearchICNListCancelSource();

        this.setState({ pagination, cancelSource: source });
        cookieServices.savePagination(this.state.pagination);

        // nuova ricerca --> resetto il focus sulla griglia
        this.props.ClearRowIndex();

        // lancio ricerca icn con i filtri selezionati
        this.props.searchICNList(data, this.state.pagination, source.token);

    }

    /**
     * ripulisce i filtri di ricerca - non lancia nuova ricerca!
     * in questo caso non devo fare nulla
     */
    handleClearSearchCallBack(){}

    componentWillReceiveProps(newProps) {
        this.setState({
            isSearching: newProps.isSearching,
            searchResults: newProps.searchResults,
            totalCount: newProps.totalCount
        });
    }

    render() {
        const { translate, currentLanguage, rowIndex } = this.props;
        const { isSearching } = this.state;

        return (
            <div>
                <div style={styles.container} >

                    <div style={styles.menuContainer}>
                            <SearchButton searchCallBack={this.handleSearchCallback}
                                searchClearCallBack={this.handleClearSearchCallBack}
                                cancelSearchCallBack={this.handleCancelSearch}
                                fullWidth={false} isSearching={isSearching} >
                            </SearchButton>
                            {
                                this.props.searchResults && this.props.searchResults.length > 0 ?
                                <FlatButton onClick={this.toggleDownloadExpand}
                                    icon={<FileFileDownload />}
                                    />
                                :
                                <div></div>
                            }

                            <Dialog
                                title={translate('Download.modalDownloadTitle')}
                                modal={false}
                                open={this.state.isDownloadExpanded}
                                autoScrollBodyContent={true}
                                onRequestClose={this.toggleDownloadExpand}>
                                <DownloadModal searchData={this.state.searchData} isIcnPlus={this.props.isIcnPlus} isDent={this.props.isDent}
                                    totalCount={this.props.totalCount} selectedDataList={this.state.selectedDataList}  />
                            </Dialog>
                    </div>
                    <div style={globalStyles.clear} ></div>
                    {
                        this.props.searchResults && this.props.searchResults.length > 0 ?
                            <AgGridTableCtrl
                                translate={translate}
                                currentLanguage={currentLanguage}
                                rowIndex = {rowIndex}
                                handleRowClicked = {this.handleRowClicked}
                                searchResults={this.props.searchResults}
                                totalCount={this.props.totalCount}
                                pageSizeList={this.state.pagination.pageSizeList}
                                selectedPageSize={this.state.pagination.selectedPageSize}
                                currentPage={this.state.pagination.currentPage}
                                handlePagination={this.handlePagination}
                                handlePageSizeChanged={this.handlePageSizeChanged}
                                handleSelectedRows = {this.handleSelectedRows}
                                isSelectedAll = {this.state.isSelectedAll}
                                handleSortChanged = {this.handleSortChanged}
                                sortName={this.state.pagination.sortName}
                                isDescending={this.state.pagination.isDescending}
                                linkGoToDetails={this.props.linkGoToDetails}
                                showSingleExport={this.props.showSingleExport}
                                isIcnPlus={this.props.isIcnPlus} isDent={this.props.isDent}
                            />
                        :
                            isSearching ? <SpinnerLoaderWithText /> : <NoResultsBox />
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        severityCodeList: state.appData.severityCodeListForDropDown,
        eventClassificationList: state.appData.eventClassificationListForDropDown,
        isSearching: state.icnSearch.isSearching,
        searchResults: state.icnSearch.list,
        totalCount: state.icnSearch.totalCount,
        rowIndex: state.grid.rowIndex
    };
}

export default connect(mapStateToProps, {searchICNList, cancelSearchICNListRequest, SaveRowIndex, ClearRowIndex})(SearchPage);



// WEBPACK FOOTER //
// ./src/containers/search/SearchPage.js